const isArray = (value) => {
  return value && value.constructor === Array;
};

export default isArray;
